import Icon from '../components/Icon.vue'

Icon.register({
  laugh: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM328 160c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM168 160c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 432c73.4 0 134-55 142.9-126 1.2-9.6-6.3-18-15.9-18h-270c-9.6 0-17.1 8.5-15.9 18 8.9 71 69.5 126 142.9 126h16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/laugh.js
// module id = 1511
// module chunks = 0